<template>
  <div class="unified-callback">
    <div v-if="loading" class="loading-overlay">
      <div class="bounce-loader">
        <div class="bounce1"></div>
        <div class="bounce2"></div>
        <div class="bounce3"></div>
      </div>
    </div>
  </div>
</template>

<script>
import hrvenueService from '../../services/hrvenue.service';
import { showNotification } from '../../static/helpers';

export default {
  name: 'UnifiedCallback',

  data() {
    return {
      loading: true,
    };
  },

  created() {
    this.handleCallback();
  },

  methods: {
    async handleCallback() {
      const lang = this.$route.params.lang === 'en' ? '' : this.$route.params.lang;

      try {
        const urlParams = new URLSearchParams(window.location.search);

        const connectionId = urlParams.get('id');
        if (!connectionId) {
          this.$router.push({
            name: 'IntegrationsView',
            params: {
              lang,
            },
          });
        }

        const connection = await hrvenueService.setConnectionId(connectionId);
        if (connection === true) {
          // Bağlantı başarılı, ana sayfaya yönlendir
          this.$router.push({
            name: 'IntegrationsView',
            query: {
              connection_success: true,
              connection_id: connection.id,
            },
            params: {
              lang,
            },
          });
        } else {
          throw new Error('Bağlantı detayları alınamadı');
        }
      } catch (error) {
        showNotification(this.resource['label.error'], error.message, 'error');

        setTimeout(() => {
          this.$router.push({
            name: 'IntegrationsView',
            query: { connection_error: true },
            params: {
              lang,
            },
          });
        }, 3000);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

  <style lang="scss" scoped>
.unified-callback {
  padding: 2rem;
  max-width: 600px;
  margin: 0 auto;
  text-align: center;
}

.loading-overlay {
  transition: visibility 0s ease-in-out 0.5s, opacity 0.5s ease-in-out;
  bottom: 0;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
  background: #fff;
  z-index: 9999;
}
.bounce-loader {
  transition: all 0.2s;
  margin: -9px 0 0 -35px;
  text-align: center;
  width: 70px;
  left: 50%;
  position: absolute;
  top: 50%;
  z-index: 10000;
}
.bounce-loader .bounce1,
.bounce-loader .bounce2,
.bounce-loader .bounce3 {
  -webkit-animation: 1.4s ease-in-out 0s normal both infinite bouncedelay;
  animation: 1.4s ease-in-out 0s normal both infinite bouncedelay;
  background-color: #ccc;
  border-radius: 100%;
  display: inline-block;
  height: 18px;
  width: 18px;
}
.bounce-loader .bounce1 {
  -webkit-animation-delay: -0.32s;
  animation-delay: -0.32s;
}
.bounce-loader .bounce2 {
  -webkit-animation-delay: -0.16s;
  animation-delay: -0.16s;
}
@keyframes bouncedelay {
  to {
    transform: scale(0);
  }
  from {
    transform: scale(1);
  }
}
</style>
